import { LitElement, html, nothing } from "lit";

import { customElement, property } from "lit/decorators.js";

import { repeat } from "lit/directives/repeat.js";
import { isProduction } from "../../../../api/helpers/isProduction.ts";
import { accordionStyles } from "./accordion.css.ts";

export interface AccordionItem {
  title: string;
  content: string;
  media?: string[];
}

@customElement("wow-accordion")
export class WowAccordion extends LitElement {
  static override styles = [accordionStyles];
  @property({ type: Array })
  items: AccordionItem[] = [];

  private handleToggle(e: ToggleEvent) {
    const details = e.currentTarget as HTMLDetailsElement;
    const isOpen = details.open;

    // Pause all videos when a <details> element is closed
    if (!isOpen) {
      const videos = details.parentElement?.querySelectorAll("video");
      videos?.forEach((video) => video.pause());
    }
  }

  private handleVideoPlay(e: Event) {
    const currentVideo = e.currentTarget as HTMLVideoElement;

    const allVideos = this.renderRoot.querySelectorAll("video");
    allVideos.forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  private generatemediaLink(media: string) {
    if (isProduction()) {
      return `https://www.worldofwow.com${media}`;
    }
    return `https://worldofwow.dev${media}`;
  }

  private renderMedia(item: AccordionItem) {
    if (item.media && item.media.length) {
      return html`${repeat(item.media, (media) => {
        const mediaLink = this.generatemediaLink(media);
        return html`<video
          class="faq-video"
          loop
          playsinline
          preload="auto"
          controls
          controlslist="nodownload"
          src="${mediaLink}"
          @play=${this.handleVideoPlay}
        >
          Your browser does not support the video tag.
        </video>`;
      })}`;
    }

    return nothing;
  }

  override render() {
    return html`
      <div class="wrapper">
        ${this.items?.map(
          (item, index) => html`
            <div class="accordion-item">
              <details aria-details=${index} @toggle=${this.handleToggle}>
                <summary>
                  ${item.title}
                  <span class="icon-expand">
                    <ph-plus-circle size="24"></ph-plus-circle>
                  </span>
                </summary>
              </details>
              <div class="content" id=${index}>${item.content} ${this.renderMedia(item)}</div>
            </div>
          `,
        )}
      </div>
    `;
  }
}
